import React from "react";
import { Card, Divider, Typography } from "antd";
import SendToFinishing from "../../../components/Kanban-Count-Accuracy/SendToFinishing/SendToFinishing";
import "../../../styles/global-ui.css";

const KanbanCountAccuracyKanbanScanPage = ({ userdata, userData }) => {
  const pageUserData = userdata || userData;

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Send to Finishing
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan or enter kanban ID to send it to finishing
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <SendToFinishing userData={pageUserData} />
      </Card>
    </div>
  );
};

export default KanbanCountAccuracyKanbanScanPage;